<template>
  <div class="main">
    <div class="main_tabs">
      <el-tabs v-model="activeName">
        <el-tab-pane label="管服人员" name="first"></el-tab-pane>
        <el-tab-pane label="劳务人员" name="second"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="main_content">
      <component :is="activeName === 'first' ? 'MortgageePossession' : 'LabourService'"></component>
    </div>
  </div>
</template>

<script>
import MortgageePossession from './components/MortgageePossession.vue';
import LabourService from "./components/LabourService.vue";
  export default {
    components: {
      MortgageePossession,
      LabourService
    },
    data() {
      return {
        activeName: 'first'
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../../style/layout-main.scss';

/deep/.main {
  background: none;
}
</style>